// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"Dashboard":1,"Toolkit":1,"Subscription":1,"ProfileSettings":1}[chunkId]) return "ZyAccount/js/chunks/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};